<template>
    <div>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'审核管理'},{name:'通知公告发布审核'}]" :title="'通知公告发布审核'"/> -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="待审核" name="1"></el-tab-pane>
              <el-tab-pane label="审核记录" name="2"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" ref="condition">
                <div class="left">
                    <div class="child" v-show="tab==='2'">
                        <span class="name">审核结果</span>
                        <el-select v-model="sendInfoOne.checkType" placeholder="请选择" size="small" clearable>
                            <el-option
							v-if="item.value!=0"
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="sendInfoOne.time"
                            format="yyyy-MM-dd HH:mm:ss"
                        	value-format="yyyy-MM-dd HH:mm:ss"
                        	type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="sendInfoOne.drop" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="sendInfoOne.dropValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <!-- 表格1 -->
            <el-table
                v-show="tab==='1'"
                :data="tableData"
                :default-sort="{prop: 'date'}"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                @sort-change="sortChange"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    label="账号">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    width="200"
                    prop="realName"
                    label="姓名" />
                <el-table-column
                    prop="title"
                    show-overflow-tooltip
                    label="附件资料标题"/>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    sortable
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain 
                        @click="check(scope.row)">查看</el-button>
                        <el-button size="small" type="success" plain  v-if="scope.row.checkStatus === 0"
                        @click="audit(scope.row)">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 表格2 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
                :default-sort="{prop: 'date'}"
                @sort-change="sortChange"
                ref="multipleTable"
                    fit
                    :height="bHeight"
                    :header-cell-style="headerStyle"
                    v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    label="账号">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="realName"
                    label="姓名" />
                <el-table-column
                    prop="title"
                    show-overflow-tooltip
                    label="附件资料标题"/>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    sortable
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="checkAccount"
                    show-overflow-tooltip
                    label="审核账号">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    sortable
                    width="150"
                    label="审核时间">
                </el-table-column>
                <el-table-column
                    prop="checkStatus"
                    show-overflow-tooltip
                    width="150"
                    label="审核结果">
                    <template slot-scope="{row}">
                      
                      <div :style="`color:${row.checkStatus === 1?'#67c23a':row.checkStatus === -1?'#f56c6c':'#409eff'}`">{{row.checkStatus | statusFilter}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain 
                        v-if="authorities.indexOf('sys:permission:background:incubator:in:apply:audit:button:view')!=-1"  
                        @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref='pagination'>
            	<Paging
            	:PageData="PageData"
            	v-if="tableData.length>0"
            	@nextpage="nextpage"
            	@previouspage="previouspage"
            	@handleSizeChange="handleSizeChange"
            	@handleCurrentChange="handleCurrentChange"
            	></Paging>
            </div>
            <!-- 弹出成模块 -->
           
           
            <!-- 审核 -->
            <el-dialog
                title="审核"
                :visible.sync="dialogAudit"
                width="30%">
                <div class="forms">
                <div class="child">
                    <div class="name"><span>*</span>审核结果：</div>
                    <el-radio-group v-model="sendInfoTwo.name4">
                        <el-radio 
                    	:label="item.value" v-for="(item,index) in auditStatus" :key="index"
                    	v-if="item.name!='审核中' && item.name!='草稿' && item.name!='已撤回'"
                    	>{{item.name}}</el-radio>
                        <!-- <el-radio :label="2">未通过</el-radio> -->
                    </el-radio-group>
                </div>
                <div class="error" v-if="errors['sendInfoTwo.name4']">错误提示：{{errors['sendInfoTwo.name4']}}</div>
                <div class="childTextarea">
                    <div class="name">说明：</div>
                    <div class="content"><el-input type="textarea" v-model="sendInfoTwo.checkRemark" show-word-limit maxlength="300"></el-input></div>
                </div>
                <div class="doubleBtn">
                    <el-button size="small" type="primary" @click="submit">确认</el-button>
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
        </div>
    </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import Paging from '../../components/Paging';
import {getDict} from "@/axios";
export default {
    components:{
        // breadcrumb,
        Paging
    },
    filters: {
    statusFilter(status) {
      const statusMap = new Map([
        [-1, '未通过'],
        [0, '审核中'],
        [1, '已通过']
      ])
      return statusMap.get(status)
    }
  },
    data(){
        return{
          loading:false,
          bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [
              {
                value: '1',
                label: '申请ID'
            },{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
            }, {
                value: '4',
                label: '公告标题'
            }],//检索下拉
			statusList: [
        {name:'全部',value:2},
        {name:'已通过',value:1},
        {name:'未通过',value:-1}
        ], //审核状态
            sendInfoOne:{
              announcementType:3,  // 类型:1=通知公告，2=协会动态，3=附加资料
                time:"",//日期
                drop:'',//检索下拉值
                dropValue:"",//检索输入值
            },//检索提交数据
            tab:'1',//选项卡
            tableData:[],//表格数据
			total:0,//总页数
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            dialogAudit:false,//审核弹出层
            dialogDetail:false,//表格内详情弹出层
            sendInfoTwo:{
            	id:'',//审核id
            	approvalModule:'announcement',//服务器审核模块
                name4:'1',//审核结果
                checkRemark:'',//说明
            },//审核提交数据
			sendInfo:{
				currentPage:1,//当前页
				pageSize:10,//页条数
        announcementType: 3, // 类型:1=通知公告，2=协会动态，3=附加资料
        createIds: void 0, // 发布人ids
        account: void 0, // 账号
        direction:void 0,//排序方式
        property:void 0,//排序字段
        id: void 0, //  申请ID
        startDate:void 0,
        endDate: void 0,
        title: void 0, // 标题
        realName: void 0 // 姓名
        
			},
			PageData:{
			  currentPage: 0,
			  total: 0, //多少條
			},
			dataInfo:'',//详细信息
      checkType: void 0,
			dataInfos:'',
            center:{},//地图中心点
            maker:{},//标记点
            zoom:15,//缩放等级
            auditStatus:[]
        }
    },
	created() {
		getDict('CHECK_STATUS').then(data=>{
		    this.auditStatus = data.CHECK_STATUS;
		})
    },
    mounted(){
      const that = this
      // 待审核
      if(this.authorities.indexOf('sys:permission:background:incubator:in:apply:unAudit')==-1){
        this.tab='2'
      }
      // 待审核 和审核记录存在一个
      if(this.authorities.indexOf('sys:permission:background:incubator:in:apply:unAudit')!=-1||this.authorities.indexOf('sys:permission:background:incubator:in:apply:audit')!=-1){
        this.getList()
      }
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfoTwo.name4':{
            test:function(){
                if(this.sendInfoTwo.name4){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择审核结果'
        },
    },
    methods:{
      onReset(){
            const param= {
              currentPage:1,//当前页
              pageSize:10,//页条数
              announcementType: 3, // 类型:1=通知公告，2=协会动态，3=附加资料
              createIds: void 0, // 发布人ids
              account: void 0, // 发布账号
              direction:void 0,//排序方式
              property:void 0,//排序字段
              id: void 0, //  申请ID
              startDate:void 0,
              endDate: void 0,
              title: void 0, // 标题
              realName: void 0 // 姓名
            }
            this.sendInfo = Object.assign(this.sendInfo,param)
            this.sendInfoOne.time='';
            this.sendInfoOne.drop='';
            this.sendInfoOne.dropValue='';
            if(this.$refs.multipleTable) this.$refs.multipleTable.clearSort()
            if(this.$refs.table) this.$refs.table.clearSort()
            this.getList()
      },
      doLayout() {
      this.$nextTick(() => {
        if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
          this.$refs.multipleTable.doLayout()
        }
        if (this.$refs.table && this.$refs.table.doLayout) {
          this.$refs.table.doLayout()
        }
      })
    },
    // 表头样式回调
    headerStyle() {
      return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
    },
		// 待审核列表
		async getList(){
			// let url='';
      this.loading = true
      const param = {...this.sendInfo}
			if(this.tab==='1'){
				 param.checkStatus = 0
			}else{
        param.checkStatus =  this.sendInfoOne.checkType || 2
      
			}
			this.$axioscBody.get('/backstage/announcement/announcementCheckList',{params:param}).then(res=>{
          this.loading = false
			    if(res.code==200){
			        this.tableData=res.data.content;
			        this.PageData.currentPage =res.data.currentPage; //当前页
			        this.PageData.total =res.data.totalElements;
			    }else{
			        this.$alert(res.msg)
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        // 切换选项啦
        changeTab:function(tab){
		    // if (this.tab&&this.tab==num){
		    //     return;
        //     }
            const param= {
              currentPage:1,//当前页
              pageSize:10,//页条数
              announcementType: 3, // 类型:1=通知公告，2=协会动态，3=附加资料
              createIds: void 0, // 发布人ids
              account: void 0, // 发布账号
              direction:void 0,//排序方式
              property:void 0,//排序字段
              id: void 0, //  申请ID
              startDate:void 0,
              endDate: void 0,
              title: void 0, // 标题
              realName: void 0 // 姓名
            }
            this.sendInfo = Object.assign(this.sendInfo,param)
            this.sendInfoOne.time='';
            this.sendInfoOne.drop='';
            this.sendInfoOne.dropValue='';
           this.tab=tab.name;
           this.getList()
        },
        //检索事件
        retrieval:function(){
			let lookData=this.sendInfoOne;
			if(lookData.time&&lookData.time.length>0){
				this.sendInfo.startDate=lookData.time[0];
				this.sendInfo.endDate=lookData.time[1];
			}else {
                this.sendInfo.startDate=null;
                this.sendInfo.endDate=null;
            }
			// 检索值
			let lookdell= parseInt(lookData.drop);
			this.sendInfo.id= void 0;
			this.sendInfo.account= void 0;
			this.sendInfo.realName= void 0;
      this.sendInfo.title = void 0;
      // this.sendInfo.checkType = this.checkType
			if(lookdell==1){
				this.sendInfo.id=lookData.dropValue;
			}else if(lookdell==2){
				this.sendInfo.account=lookData.dropValue;
			}else if(lookdell==3){
        this.sendInfo.realName=lookData.dropValue;
      }else{
				this.sendInfo.title=lookData.dropValue;
			}
			this.getList()
		},
        //地图创建
		async handler({BMap, maps}){
		    this.center=this.center;
		    this.marker=this.marker;
		},
        // handler:function({BMap, map}){
        //     this.center={lng: 116.404, lat: 39.915};
        //     this.maker={lng: 116.404, lat: 39.915};
        //     this.zoom=15;
        // },
        //表格排序事件
            sortChange: function ({column, prop, order}) {
                if (order == 'ascending') {
                    order = 'ASC';
                } else {
                    order = 'DESC';
                }
                this.sendInfo.property = prop;
                this.sendInfo.direction = order;
                this.getList();
            },
        //分页功能模块
        // 下一頁
        nextpage(val) {
          this.sendInfo.currentPage=val;
          this.getList()();
        },
        // 上一頁
        previouspage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        handleSizeChange(val) {
          this.sendInfo.pageSize = val;
          this.getList()
        },
        handleCurrentChange(val) {
        	this.sendInfo.currentPage=val;
          this.sendInfo.currentPage = val;
          this.getList()
        },
        //查看明细
        check:function(row){
            this.$router.push({path: `/auditsManagement/enclosure/detail/${this.tab}/${row.id}`, query: {index: '/auditsManagement/enclosure'},param:{id:row.id,tab:this.tab}})
        },
        //下载附件
        downLoad:function(url){
			window.open(url)
		},
        //打开审核
        audit:function(row){
            this.sendInfoTwo.id=row.id;
            this.dialogAudit=true;
            this.sendInfoTwo.checkRemark='';
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
			if(this.$vuerify.check()){
				let auditInfo={
					id: this.sendInfoTwo.id,
					approvalModule: this.sendInfoTwo.approvalModule,
					checkRemark: this.sendInfoTwo.checkRemark,
					result: this.sendInfoTwo.name4
				}
				this.$axiosc.put('/backstage/common/approval',this.$qs.stringify(auditInfo)).then(res=>{
					if(res.code==200){
						this.$message({
							type: 'success',
							message: res.msg
						});
						this.dialogAudit=false;
						this.getList()
					}else{
						this.$message.warning(res.msg)
					}
				})
			}
        }
    },
	watch:{
		'sendInfoOne.drop': {
        handler(val, oldVal) {
         this.sendInfoOne.dropValue=''
        },
        deep: true
      }
	}
}
</script>

<style lang="scss" scoped>
.content-img{
		position: relative;
		width: 117px;
		height: 117px;
		float: left;
		margin-right: 20px;
		margin-bottom: 20px;
		div{
			position: absolute;
			top: 0;
			right: 0;
			z-index: 100;
			color: #fff;
			background: #2D2D2D;
			font-size: 14px;
			padding: 3px;
		}
	}
  .doubleBtn{
  justify-content: flex-end !important;
}
</style>